import { getRequest } from "../BackendService";
import axios from "axios";

const getFeatureFlagsListUrl = `/v2/feature-flag?project_id=${process.env.REACT_APP_FEATURE_FLAG_PROJECT_ID}`;
const getFeatureFlagProjectDetailsUrl = `/v2/feature-flag/project/${process.env.REACT_APP_FEATURE_FLAG_PROJECT_ID}`;

export const getFeatureFlagsList = async (): Promise<any> => {
	try {
		const resp = await axios(
			getRequest(getFeatureFlagsListUrl, null, false, false, false)
		);
		return resp.data.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getFeatureFlagProjectDetails = async (): Promise<any> => {
	try {
		const resp = await axios(
			getRequest(
				getFeatureFlagProjectDetailsUrl,
				null,
				false,
				false,
				false
			)
		);
		return resp.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
